export class graphqlbase {
  constructor (base) {
    this.base = base
    this.loader = null
    this.template = ''
    this.use_loader = true
  }

  build_nodequery (fields, filter) {
    //const Query = require('graphql-query-builder')

    let nodequery = new Query('nodeQuery')
    nodequery.filter(filter)

    let entityquery = new Query('entities')
    entityquery.find(fields)

    nodequery.find(entityquery)

    return 'query BasicQuery{ ' + nodequery.toString() + '}'
  }

  fetch () {
    const _this = this

    try {
      if (this.use_loader === true) {
        this.loader = $.loader.init(this.base).show()
      }

      const url = window.main.graphql_server + '?' + queryString.stringify({
        'query': this.query
      })

      const promise = fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
      })
      .then(r => r.json())
      .then(data => _this.render(data.data.events.nodes))

      return promise
    } catch (e) {
      alert(e)
    }
  }

  render (data) {
    console.log(data)
  }

  render_list (entities, _callback) {
    const template = require('../templates/_base/list.tpl')
    const rendered_items = entities.map(_callback)

    return template({
      items: rendered_items
    })
  }
}
